type SortMappingType = {
  [key: string]: {
    field: string;
    order: string;
  }
};

type SortDisplayMappingType = {
  [key: string]: {
    display_option: string;
    order: string;
  }
};

export const displayOptions = [
  { value: 'all', label: 'All' },
  { value: 'published', label: 'Published' },
  { value: 'not_published', label: 'Unpublished' },
];

export const sortOptions = [
  { value: 'updated_at_newer', label: 'Last edited: Newest' },
  { value: 'updated_at_older', label: 'Last edited: Oldest' },
  { value: 'created_at_newer', label: 'Created: Newest' },
  { value: 'created_at_older', label: 'Created: Oldest' },
  { value: 'title', label: 'Title (A-Z)' },
];

export const sortMapping: SortMappingType = {
  updated_at_newer: { field: 'updated_at', order: 'desc' },
  updated_at_older: { field: 'updated_at', order: 'asc' },
  created_at_newer: { field: 'created_at', order: 'desc' },
  created_at_older: { field: 'created_at', order: 'asc' },
  title: { field: 'title', order: 'asc' },
};

export const sortDisplayMapping: SortDisplayMappingType = {
  all: { display_option: 'all', order: 'desc' },
  published: { display_option: 'published', order: 'desc' },
  not_published: { display_option: 'not_published', order: 'desc' },
};
